export enum Gesture {
    Empty = "",
    None = "NONE",
    Left = "LEFT",
    Right = "RIGHT",
    Up = "UP",
    Down = "DOWN",
    Tap = "TAP",
    DragLeftAndRight = "DRAGLEFTANDRIGHT",
    DragUpAndDown = "DRAGUPANDDOWN"
  }